import { StateCard } from '@/components/ui/State';
import { RadioTower } from 'lucide-react';

export function LoadingScreen() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <StateCard
        icon={<RadioTower className="h-10 w-10 animate-signal-pulse" />}
        title="Yükleniyor"
        message="RadioAtlas hazırlanıyor..."
        className="bg-transparent"
      />
    </div>
  );
}

export default LoadingScreen;
